import { useState, useEffect } from "react";
import { WHATSAPP_URL } from "@/constants/contact";
import { navLinks } from "@/mocks/landingData";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 right-0 left-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#030712]/80 backdrop-blur-xl border-b border-white/5 shadow-[0_8px_32px_rgba(0,0,0,0.4)]"
          : "bg-transparent"
      }`}
    >
      <div className="container-main flex items-center justify-between py-4 px-4 md:px-8">
        <a
          href="#hero"
          onClick={() => handleNavClick("#hero")}
          className="flex items-center gap-3"
        >
          <img
            src="/logo.png?v=2"
            alt="أوامر الشبكة"
            className="h-14 md:h-16 w-auto object-contain brightness-110"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="text-sm font-medium text-slate-300 hover:text-teal-300 px-4 py-2 rounded-full hover:bg-white/5 transition-all whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="v2-cta-primary text-sm py-2.5 px-6"
          >
            <i className="ri-phone-line" />
            استشارة مجانية
          </a>
        </div>

        <button
          className="lg:hidden p-2 text-slate-200"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="القائمة"
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`} />
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-[#0f172a]/95 backdrop-blur-xl border-t border-white/10">
          <nav className="flex flex-col p-4 gap-1">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNavClick(link.href)}
                className="text-right text-slate-200 font-medium py-3 px-4 rounded-xl hover:bg-white/5 hover:text-teal-300 transition-colors"
              >
                {link.label}
              </button>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="v2-cta-primary text-sm py-3 justify-center mt-2"
            >
              <i className="ri-phone-line" />
              استشارة مجانية
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
